'use client';
import React from 'react';
import Modal from '../modal';

interface PopupConfirmProps {
  open?: boolean;
  loading?: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  centered?: boolean;
}

const PopupConfirm: React.FC<PopupConfirmProps> = ({
  open,
  title,
  message,
  confirmText,
  cancelText,
  centered,
  loading,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
    confirmLoading={loading}
      open={open}
      centered={centered}
      textCancel={cancelText}
      textSubmit={confirmText}
      onCancel={onCancel}
      onOk={onConfirm}
    >
      <div className='m-popup-confirm'>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
    </Modal>
  );
};

export default PopupConfirm;
